// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"styles_text-gradient__VdsJp","popoverContainer":"styles_popoverContainer__3U0mg"};